import './index.scss';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { useGetFolders } from '@/src/components/project/Library/api/getFolders';
import { useMoveFolder } from '@/src/components/project/Library/api/moveFolder';
import { showToast } from '@/src/globalFunction';
import { RootState } from '@/src/reducers/types';
import { cn } from '@/src/util/ui';

import Folder from './Folders/Folder/Folder';
import Folders from './Folders/Folders';

const FoldersModal = ({ onClose, itemIdsVersioned, shouldResetSelected = true, onMoved }) => {
  const { projectId } = useParams<{ projectId: string }>();
  const dispatch = useDispatch();
  const files = useSelector((state: RootState) => state.files);
  const foldersQuery = useGetFolders({ projectId: +projectId });
  const moveFolderMutation = useMoveFolder();

  const [selected, setSelected] = useState(null);
  const [togglers, setTogglers] = useState([]);

  const handleMove = async () => {
    if (!selected) return;

    const previousParentId = files.activeFolder.id;

    const response = await moveFolderMutation.mutateAsync({
      itemIdsVersioned,
      parentId: selected.id,
    });

    if (response['error-results'].length > 0) {
      showToast('error', 'Something went wrong. Please try again later.');
      return;
    }

    if (response['conflict-results'].length > 0) {
      showToast('error', 'The document has already been upated. Please refresh and try again.');
      return;
    }

    if (onMoved && response['success-results'].length > 0) {
      onMoved({
        itemIdsVersioned: response['success-results'].map((f) => ({
          id: f.id,
          version: f.version,
        })),
        previousParentId,
      });
    }

    if (shouldResetSelected) {
      dispatch({ type: 'RESET_SELECTED_ITEMS' });
      onClose();
    }
  };

  const handleClose = () => {
    setSelected(null);
    $('#moveFiles').modal('hide');

    if (onClose) {
      onClose();
    }
  };

  const handleToggles = (bool, toggle) => {
    setTogglers(bool ? togglers.filter((t) => t !== toggle) : [...togglers, toggle]);
  };

  return (
    <>
      <div
        className="modal fade show in move-files-modal bg-overlay"
        data-backdrop="static"
        data-keyboard="false"
        id="moveFiles"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bb pd20 pdl40 pdr40">
              <div className="row">
                <div className="col-lg-10 col-md-10 col-sm-10">
                  <p className="text-size18 brndnTxt-m mb0 mt5">Move Files/Folders</p>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <a className="text-right" onClick={handleClose}>
                    <i className="material-icons text-size22">close</i>
                  </a>
                </div>
              </div>
            </div>
            <div className="modal-body">
              <div className="folderHeader">Library</div>
              <div className="folderList">
                <ul className="folderListContainer">
                  <Folder
                    key={'library'}
                    file={{
                      id: null,
                      name: 'Library',
                    }}
                    onToggler={handleToggles}
                    togglers={togglers}
                    selected={selected}
                    disabled={files.activeFolder === 'null'}
                    onSetSelected={(file) => setSelected(file)}
                  />
                  <Folders
                    folders={foldersQuery.data.data}
                    selected={selected}
                    onToggler={handleToggles}
                    togglers={togglers}
                    onSetSelected={(file) => setSelected(file)}
                    originalSelected={files.activeFolder}
                  />
                </ul>
              </div>
            </div>
            <div className="modal-footer bt">
              <div className="footerActions">
                <div className="actionButton">
                  <button type="button" className="btn btnCancel" onClick={handleClose}>
                    Cancel
                  </button>
                </div>
                <div className="actionButton others">
                  <button
                    type="button"
                    className={cn('btnSend ', selected && 'active')}
                    onClick={() => handleMove()}
                  >
                    Move
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FoldersModal;
